import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ISavedColor } from '../../../hooks/colorPicker/useSavedColors'
import { Draft, produce } from 'immer'

export interface INewSaveColor {
  id: string
  color: ISavedColor
}

export const stateDefaultsavedColors: Record<string, ISavedColor[]> = {}

const savedColorsSlice = createSlice({
  name: 'savedColors',
  initialState: stateDefaultsavedColors,
  reducers: {
    saveNewColor: (state, action: PayloadAction<INewSaveColor>) => {
      return produce(state, (draft: Draft<Record<string, ISavedColor[]>>) => {
        if (draft[action.payload.id])
          draft[action.payload.id].push(action.payload.color)
        else draft[action.payload.id] = [action.payload.color]
      })
    },
  },
})

export const { saveNewColor } = savedColorsSlice.actions
export default savedColorsSlice
